export function privilegesDuRole(configuration, role, catalogue = []) {
  const nominatifs = new Set((catalogue || []).filter((privilege) => privilege.nominatif).map((privilege) => privilege.key));
  return Object.keys(configuration).filter((cle) => configuration[cle][role] && !nominatifs.has(cle));
}
